import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getCustomFieldTypeCombo from '../../services/customFieldType/getCustomFieldTypeCombo'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchCustomFieldTypesCombo () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const customFieldTypesCombo = yield call(getCustomFieldTypeCombo, auth.token)
    yield put(fetchCombosSuccess({ customFieldTypesCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }

    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchCustomFieldTypesCombo () {
  yield takeLatest(combosActionTypes.FETCH_CUSTOM_FIELD_TYPES_COMBO, fetchCustomFieldTypesCombo)
}
